import {ReactNode} from "react";
import {Button, Spinner} from "react-bootstrap";

export function SubmitButton({busy, children, variant = 'primary', className}: { busy: boolean, children: ReactNode, variant?: string, className?: string }) {
    return (
        <Button type="submit" variant={variant} disabled={busy} className={className}>
            {busy && <Spinner size="sm" className="me-2"/>}{children}
        </Button>
    );
}
